"use client"

import Link from 'next/link';
import { useTranslations } from 'next-intl';
import React from 'react'
import { ArrowRight } from 'lucide-react';

interface PrimaryBtnProps {
    className?: string;
    translationKey?: string;
    translationNamespace?: string;
    fallbackText?: string;
    /** CMS or caller override; takes precedence over i18n */
    labelOverride?: string;
    route: string
}

const PrimaryBtn: React.FunctionComponent<PrimaryBtnProps> = (
    {
        className = "",
        translationKey = "generateYourStrategy",
        translationNamespace = "Hero",
        fallbackText = "Generate Your Strategy",
        labelOverride,
        route,
    }
) => {
    const t = useTranslations(translationNamespace);

    // Get translation with fallback
    let buttonText = fallbackText;
    const override = labelOverride?.trim();
    if (override) {
        buttonText = override;
    } else {
        try {
            const translated = t(translationKey);
            if (translated && !translated.startsWith(`${translationNamespace}.`)) {
                buttonText = translated;
            }
        } catch {
            buttonText = fallbackText;
        }
    }


    return (
        <Link
        href={route}
        className={`inline-flex items-center gap-2 px-4 sm:px-6 md:px-8 py-2.5 sm:py-3 md:py-4 bg-[#3541ED] 
        text-[#FFFFFF] text-sm sm:text-base md:text-[18px] font-semibold rounded-[24px] hover:bg-[#3541ED]/90 
        transition-all duration-200 ${className}`}
        >
            <span>{buttonText}</span>
            <ArrowRight className="size-[18px] sm:size-[20px]" />
        </Link>
    )
}

export default PrimaryBtn